import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'umi';
import { Checkbox, Justify } from 'tea-component';
import { getTrendDateInfo } from '@/pages/datalab/utils/utils';
import DimNumberTrendCard from "@customComp/DimNumberTrendCard";
import SvgIcon from "@home/components/SvgIcon";
import './index.scss';
import {formatDisplayValue} from "@customComp/Chart/_config/_utils";


const DimNumberTrendWrap = (props: any) => {
  const {
    chartData,
    filtersArr,
    columnX,
    headerRight,
    isFromAdd,
    trendStatus: oldTrendStatus,
    onStatusChange,
    metricInfo,
  } = props;
  const { formatMessage } = useIntl();
  const { lineData, rankData } = chartData || {};
  const [trendStatus, setTrendStatus] = useState({
    showStaticTime: isFromAdd,
    ...(oldTrendStatus || {}),
  });

  useEffect(() => {
    setTrendStatus({
      showStaticTime: isFromAdd,
      ...(oldTrendStatus || {}),
    });
  }, [isFromAdd, oldTrendStatus]);

  // 从添加页面进来，默认勾选显示日期，将状态保持到model层
  useEffect(() => {
    if (isFromAdd) {
      onStatusChange?.({
        showStaticTime: isFromAdd,
      });
    }
  }, [isFromAdd]);

  const { metricData, metricKey, metricName, granularity, isSingle, isHourDate } = useMemo(() => {

    try {

      const { lineData, trend_metric = {}, metrics } = chartData || {};

      // 1. 趋势图和数字卡片需要的日期粒度和是否为单点日期的信息
      const { id } = columnX?.[0] || {}; // 数字趋势图卡片只有一个日期维度
      const { column_value = [], dateType = 'day' } = filtersArr?.find((filter: { id: string; }) => filter.id === id) || {};
      const { granularity, isSingle } = getTrendDateInfo({ value: column_value, dateType });


      // 2. 同环比或变化率
      const changData: { dod?: number; sdlw?: number; change?: number; } = {
        change: trend_metric?.change
      };
      switch (granularity) {
        case 'day': {
          changData.dod = trend_metric?.dod;
          changData.sdlw = trend_metric?.sdlw;
          break;
        }
        case 'week': {
          changData.dod = trend_metric?.wow;
          changData.sdlw = trend_metric?.swlm;
          break;
        }
        case 'month': {
          changData.dod = trend_metric?.mom;
          changData.sdlw = trend_metric?.smly;
          break;
        }
      }
      return {
        metricData: {
          trendChartData: lineData?.[0]?.[0]?.metrics || [],
          dod: {...changData?.dod, extendFormatRule: {type: metricInfo?.unit || 'bmk', decimal: metricInfo?.accuracy || 0}},
          sdlw: {...changData?.sdlw, extendFormatRule: {type: metricInfo?.unit || 'bmk', decimal: metricInfo?.accuracy || 0}},
          change: {...changData?.change, extendFormatRule: {type: metricInfo?.unit || 'bmk', decimal: metricInfo?.accuracy || 0}},
          metricValue: formatDisplayValue({
            value: trend_metric?.value,
            isPercent: metricInfo?.column_date_type === 'percent',
            accuracy: metricInfo?.accuracy || 0,
            unit: metricInfo?.unit || 'bmk',
          }),
          staticTime: trend_metric?.date,
        },
        metricKey: metrics?.[0],
        metricName: metrics?.[0]?.replace(/(t[0-2]_)/, '') || '',
        granularity,
        isSingle,
        isHourDate: dateType === 'hour',
      };

    } catch (e) {

      console.log("图表趋势图卡片数据转换错误: ", e);
      return { isDataError: true, isDataLoading: false };
    }

  }, [chartData, metricInfo]);

  return (<div className={`dbl-trend-wrap`}>
    <Justify
      className='dbl-trend-wrap-header'
      left={<Checkbox
        value={trendStatus.showStaticTime}
        onChange={(value) => {
          setTrendStatus({ ...trendStatus, showStaticTime: value });
          onStatusChange?.({ showStaticTime: value });
        }}>
        {formatMessage({ id: 'dbl_common_show_static_time' })}
      </Checkbox>
      }
      right={headerRight}
    />
    <div className={`dbl-dimension-number-trend-wrap`}>
      <Justify
        left={
          <div className='dbl-dimension-number-trend-chart-header'>
            <SvgIcon type={'plate'} />{metricName}
          </div>
        }
      />
      <DimNumberTrendCard
        metricData={metricData}
        lineData={lineData}
        rankData={rankData}
        metricKey={metricKey}
        metricName={metricName}
        granularity={granularity}
        isSingle={isSingle}
        height={100}
        isShowTrend={!isHourDate}
        isShowDod={!isHourDate}
        isShowStaticTime={trendStatus?.showStaticTime}
        metricInfo={metricInfo}
      />
    </div>
  </div>);
};

export default DimNumberTrendWrap;
